import { injectable } from "inversify"

import * as Api from "../constants/ApiUrlConstants"
import container from "../wires/Bootstrapper"
import SERVICE_IDENTIFIER from "../wires/Identifiers"

import { IApiService } from "./shared/ApiService"
import { IApiServiceExt } from "./shared/ApiServiceExt";

import { ClienteModel } from "../models/ClienteModels";
import { ModelBase } from "../models/ModelBase";

export interface IClienteService {
    Get(): Promise<ClienteModel>
    Save(data: ClienteModel): Promise<ModelBase>
}

@injectable()
export class ClienteService implements IClienteService {

    apiService: IApiService
    apiServiceExt: IApiServiceExt

    constructor() {
        this.apiService = container.get(SERVICE_IDENTIFIER.API_SERVICE)
        this.apiServiceExt = container.get(SERVICE_IDENTIFIER.API_SERVICE_EXT)
    }

    async Get(): Promise<ClienteModel> {
        return await this.apiService.getAsync<ClienteModel>(Api.ClienteGet, {})
    }

    async Save(data: ClienteModel): Promise<ModelBase> {
        return await this.apiServiceExt.postAsync<ModelBase>(Api.ClienteSave, data)
    }
}